import { render } from "./Game.vue?vue&type=template&id=2efab81e"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=2efab81e&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\灵域传说\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__